import React from 'react';
import { connect } from 'react-redux';
import { firstError } from '@/utils/errors';
import findResult from '@/utils/resultsHelper';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import { showShareCollection } from '../actions';

const ShareCollectionAction = ({
  category,
  code,
  readErrors,
  share,
  secureOnly,
  disabled,
}) => (
  <RibbonMenu
    name="share"
    icon={secureOnly ? 'shield' : 'share alternate'}
    message={secureOnly ? 'actions.security' : 'actions.share'}
    onClick={() => share(category, code)}
    className="aridhia-share-collection-action"
    disabled={firstError(readErrors) !== null || disabled}
  />
);

const mapStateToProps = ({
  collections: { collections },
}, { category, code }) => {
  const collection = findResult(collections, category, code);

  return {
    readErrors: collection ? collection.readErrors : [],
    name: collection ? collection.name : null,
  };
};

const mapDispatchToProps = {
  share: showShareCollection,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareCollectionAction);
